// project-imports
import navigation from './navigation';
import locationsComponents from './locations';
import menuComponents from './menu';
import userManagementComponents from './user-management';
import webComponents from './web-content';
import enquiresComponents from './enquiries';
import couponsComponents from './coupons';

// ==============================|| MENU ITEMS ||============================== //

const menuItems = {
  items: [navigation , userManagementComponents,locationsComponents, menuComponents,webComponents, enquiresComponents, couponsComponents]
};

export default menuItems;
